import { Gateways } from 'types/api-types';

type GatewayObject = {
  [key in Gateways]: string;
};

export const gatewayList: GatewayObject = {
  gemstones: CONFIG.API_GEMSTONES_GATEWAY_URL
};
